import { Link, useSearchParams } from "react-router-dom";

export function CrmLeadConvertedPage() {
  const [searchParams] = useSearchParams();
  const accountId = searchParams.get("accountId");

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold text-slate-900 dark:text-white">Lead converted</h1>
      <p className="text-sm text-slate-600 dark:text-slate-400">
        This lead was converted successfully. Open the account or return to leads to continue.
      </p>
      <div className="flex flex-wrap gap-2">
        {accountId ? (
          <Link
            to={`/crm/accounts/${encodeURIComponent(accountId)}`}
            className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white hover:bg-indigo-500"
          >
            Open account
          </Link>
        ) : null}
        <Link
          to="/crm/leads"
          className="rounded-md border border-gray-300 px-3 py-2 text-sm font-semibold hover:bg-gray-50 dark:border-white/20 dark:hover:bg-white/10"
        >
          Back to leads
        </Link>
      </div>
    </div>
  );
}
